import { defineChain } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

const sourceId = 11_155_111; // sepolia

export const plume = defineChain({
  id: 98_866,
  name: "Plume",
  chainNamespace: "eip155",
  caipNetworkId: `eip155:${98_866}`,
  nativeCurrency: {
    name: "Plume",
    symbol: "PLUME",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.plume.org"],
      webSocket: ["wss://rpc.plume.org"],
    },
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://explorer.plume.org",
      apiUrl: "https://explorer.plume.org/api",
    },
  },
});

export const plumeTestnet = defineChain({
  id: 98_867,
  chainNamespace: "eip155",
  caipNetworkId: "eip155:98867",
  name: "Plume Testnet",
  nativeCurrency: {
    name: "PLUME Sepolia",
    symbol: "PLUME",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://testnet-rpc.plumenetwork.xyz"],
      webSocket: ["wss://testnet-rpc.plumenetwork.xyz"],
    },
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://testnet-explorer.plumenetwork.xyz",
      apiUrl: "https://testnet-explorer.plumenetwork.xyz/api",
    },
  },
  testnet: true,
  sourceId,
});

export const projectId = import.meta.env.VITE_WALLET_CONNECT_PROJECT_ID;
export const wagmiAdapter = new WagmiAdapter({
  networks: [plume],
  projectId,
  ssr: false,
});
